import React from 'react';
import { isMobile } from '@benzinga/device-utils';
import { useEffectDidMount } from './useEffectDidMount';

export const useFirstInteractionMade = () => {
  const [interactionMade, setInteractionMade] = React.useState(false);

  useEffectDidMount(() => {
    if (isMobile()) {
      window.addEventListener(
        'touchstart',
        () => {
          setInteractionMade(true);
        },
        { once: true },
      );
    } else {
      window.addEventListener(
        'mousemove',
        () => {
          setInteractionMade(true);
        },
        { once: true },
      );
    }
  });

  return interactionMade;
};
